import drApi from '../images/drwhoapi.png'
import webScraper from '../images/webscraper.jpg'
import converter from '../images/converter.png'
import gradBorder from '../images/grad-border.jpg'
import charCard from '../images/charcard.jpg'


export const experiments = [
    {
        id: "01", 
        title: "Mock API",
        url: "https://the-dr-who-api.herokuapp.com/",
        image: drApi
    },
    {
        id: "02", 
        title: "Web Scraper",
        url: "https://dr-who-web-scraper.herokuapp.com/",
        image: webScraper
    }, 
    {
        id: "03", 
        title: "Crypto Converter",
        url: "https://github.com/Alliemack77/Crypto-Converter-with-React-and-Node.js",
        image: converter
    },
    {
        id: "04", 
        title: "Gradient Border",
        url: "https://codepen.io/alliemack/pen/YzYLONx?editors=1100",
        image: gradBorder
    },
    {
        id: "05", 
        title: "Character Cards",
        url: "https://codepen.io/alliemack/pen/xxpBReN",
        image: charCard
    },

]